require('./../../plugins/fileuploader/dist/jquery.fileuploader.min.js');

Vue.component('profile-info', require('./../components/host-profile/profile-info.vue').default);
Vue.component('ad-share-modal', require('./../components/ad/ad-share/ad-share-modal.vue').default);
